// extracted by mini-css-extract-plugin
module.exports = {"Item":"InfoItem_Item__efmlC","arrow-left":"InfoItem_arrow-left__0eWOb","arrow-right":"InfoItem_arrow-right__FMdYc"};